import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import ADD_CONTEST from "mutations/contests/addContest";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { contests: { GET_CONTESTS } } = queries;
const usePrepareComponent = () => {
    const history = useHistory();
    const [addContent, { loading }] = useMutation(ADD_CONTEST, {
        refetchQueries: [GET_CONTESTS]
    });
    const [getContents] = useLazyQuery(GET_CONTESTS);
    const onCancel = () => {
        history.push(`/contests`);
    };
    const onSave = (itemAdd) => {
        addContent({
            onCompleted: () => {
                getContents({
                    fetchPolicy: "network-only",
                    onCompleted: () => {
                        history.push(`/contests`);
                    }
                });
            },
            variables: {
                contestAddInput: {
                    ...itemAdd,
                    slug: itemAdd.slug ?? "",
                    title: itemAdd.title ?? ""
                }
            }
        });
    };
    return {
        loading,
        onCancel,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Add);
